exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#shortcode-list-modal .tab-content,#shortcode-list-modal .tab-content>.active{width:100%!important}#shortcode-list-modal .tab-content>.active{overflow:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-28b01a74","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/components/short-codes/ShortCodeListModal.vue
// module id = 1122
// module chunks = 0